<template>
    <div class="box">
        <div class="level box-header">
            <div class="level-item">
                <div>
                    <p class="subtitle is-5">Pedido</p>
                    <p class="subtitle is-5"><strong>{{ order.id }}</strong></p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="subtitle is-5">Estado</p>
                    <p class="subtitle is-5"><strong>{{ stateName }}</strong></p>
                </div>
            </div>
            <!-- <div class="level-item">
                <div>
                    <p class="subtitle is-5">Fecha de Entrega</p>
                    <p class="subtitle is-5"><strong>{{ order.deliveryDate | moment('D/M/Y') }}</strong></p>
                </div>
            </div> -->
            <div class="level-item">
                <div>
                    <p class="subtitle is-5">Total</p>
                    <p class="subtitle is-5"><strong>{{ order.total | toCurrency }}</strong></p>
                </div>
            </div>
        </div>

        <div class="box-content">
            <!-- <div class="columns">
                <div class="column" v-if="order.shippingAddress">
                    <p><b>Direccion de Entrega</b></p>
                    <p v-if="order.shippingAddress">{{ order.shippingAddress.formattedAddress }}</p>
                </div>

                <div class="column" v-if="order.billingAddress">
                    <p><b>Datos de Facturacion</b></p>
                    <p v-if="order.billingAddress">{{ order.billingAddress.name }}</p>
                    <p v-if="order.billingAddress">{{ order.billingAddress.address }}</p>
                    <p v-if="order.billingAddress">{{ order.billingAddress.area }}</p>
                </div>
            </div> -->

            <table class="table is-fullwidth is-narrow">
                <thead>
                    <tr>
                        <th>Detalle</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                        <th>Subtotal</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, index) in order.items" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>$ {{ item.price }}</td>
                        <td>$ {{ item.quantity * item.price }}</td>
                    </tr>
                </tbody>
            </table>

            <!--<p><b>Pagos</b></p>-->
        </div>
    </div>
</template>

<script>
    export default {      
        props: {
            order: {
                type: Object
            }
        },

        data() {
            return {

            }
        },

        computed: {
            stateName() {
                let name = this.order.state;

                switch (this.order.state) {
                case 'state.open':
                    name = 'Pendiente';
                    break;
                case 'state.closed':
                    name = 'Completado';
                    break;
                case 'state.cancelled':
                    name = 'Cancelado';
                    break;
                }

                if(this.shrink && this.$vuetify.breakpoint.smAndDown) {
                    name = name.charAt(0);
                }

                return name;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .box {
        padding: 0px;
    }

    .box .box-header {
        padding: 10px;
        background-color: #dbdbdb;
    }

    .box .box-content {
        padding: 20px;
    }

    table {
        margin-top: 10px;
    }

    table td {
        border: none;
    }
</style>